<template>
  <div class="page" ref="body">
    <div style="display:none" v-title>登录 - 唯丝普</div>
    <template v-if="!noRights">
      <div class="login-header"></div>
      <div class="login-form">
        <div class="input-item">
          <i class="wsp-icon icon-mobile"></i>
          <input type="text" v-model="tel" placeholder="请输入手机号码" />
        </div>
        <div class="input-item">
          <i class="wsp-icon icon-pwd"></i>
          <input type="password" v-model="pwd" placeholder="请输入密码" />
        </div>
      </div>
      <div class="wsp-btn-l" @click="toLogin">登录</div>
      <div class="other-option clearfix">
        <router-link :to="{ name: 'Register', query: { comcode: comcode, openid: openid }}"><span class="fl">注册</span></router-link>
        <router-link :to="{ name: 'Forget', query: { comcode: comcode, openid: openid }}"><span class="fr">忘记密码</span></router-link>
      </div>
      <i class="wsp-logo" v-show="showLgo"></i>
    </template>
    <template v-if="noRights">
      <div class="no-rights">参数错误！</div>
    </template>
  </div>
</template>

<script>
import { Toast } from 'mint-ui'
import md5 from 'js-md5'
import { validateTel, validateEmpty } from '../utils/validator'
export default {
  name: 'Login',
  data () {
    return {
      showLgo: true,
      tel: '',
      pwd: '',
      noRights: false,
      comcode: '',
      openid: ''
    }
  },
  components: {
    Toast
  },
  created: function () {
    let secret = 'tL92QZVP5WS1b7X8'
    let appkey = 'b9916545aR3c35E71fYFedq3b8i6ea9f'
    let formet = 'json'
    let serial = Date.parse(new Date()) / 1000
    let ver = '1.0'

    this.comcode = this.$route.query.comcode
    this.openid = this.$route.query.openid
    let sign = md5(secret + appkey + this.comcode + formet + serial + ver)
    let params = {
      serial: serial,
      ver: ver,
      formet: formet,
      secret: secret,
      appkey: appkey,
      sign: sign,
      comcode: this.comcode
    }
    // 反馈
    this.$axios.get('/Index/Doctor/LoginPage', { params: params }).then((response) => {
      if (response.data.code !== 1000) {
        Toast({
          message: '参数错误！',
          duration: 1500
        })
        this.noRights = true
      }
    }).catch(function () {})
  },
  mounted () {
    this.$nextTick(() => {
      let windheight = document.documentElement.clientHeight
      window.addEventListener('resize', () => {
        var docheight = document.documentElement.clientHeight
        if (docheight < windheight) {
          this.showLgo = false
        } else {
          this.showLgo = true
        }
      })
    })
  },
  methods: {
    // 检测报告详情
    toReport () {
      this.$router.push({
        path: 'Medical',
        query: {
          checkid: 306605,
          userid: 522886
        }
      })
    },
    // 登录
    toLogin () {
      if (validateEmpty(this.tel)) {
        Toast({
          message: '请输入手机号码！',
          duration: 1500
        })
        return
      }
      if (validateTel(this.tel)) {
        Toast({
          message: '请输入正确的手机号码！',
          duration: 1500
        })
        return
      }
      if (validateEmpty(this.pwd)) {
        Toast({
          message: '请输入用户密码！',
          duration: 1500
        })
        return
      }
      let secret = 'tL92QZVP5WS1b7X8'
      let appkey = 'b9916545aR3c35E71fYFedq3b8i6ea9f'
      let formet = 'json'
      let serial = Date.parse(new Date()) / 1000
      let ver = '1.0'

      let passwordMd5 = md5(this.pwd)
      let phone = this.tel

      let sign = md5(secret + appkey + formet + passwordMd5 + phone + serial + ver)
      let params = {
        serial: serial,
        ver: ver,
        formet: formet,
        secret: secret,
        appkey: appkey,
        sign: sign,
        phone: phone,
        password: passwordMd5
      }
      this.$axios.get('/Index/Doctor/Login', { params: params }).then((response) => {
        if (response.data.code === 1000) {
          Toast({
            message: '登录成功！',
            position: 'bottom',
            duration: 1500
          })
          let params = response.data.data[0]
          localStorage.setItem('userInfo', JSON.stringify(params))
          this.$store.dispatch('setUser', params)
          this.$router.replace({
            path: '/Doctor/UserCenter',
            query: {
              comcode: this.comcode,
              openid: this.openid,
              doctorid: response.data.data[0].doctorid
            }
          })
        } else {
          Toast({
            message: '登录失败！',
            position: 'bottom',
            duration: 1500
          })
        }
      }).catch(function () {})
    }
  }
}
</script>
<style lang="stylus" scoped>
.page
  margin 0 auto
  width 530px
.login-header
  width 240px
  height 73px
  margin 0 auto
  background-image url('../assets/images/login-logo.png')
  background-size 240px 73px
  margin-top 150px
  font-size: 24px; /*px*/
.login-form
  margin-top 190px
  width 520px
  .input-item
    margin-bottom 50px
  input
    border-bottom: 1px solid #eaeaea; /*no*/
    width 448px
    height 46px
    // padding-bottom 10px
    line-height 46px
    margin-left 20px
    font-size: 26px; /*px*/
    background-color transparent
    color #333
.icon-mobile
  display inline-block
  width 35px
  height 46px
  background-image url('../assets/images/icon-mobile.png')
.icon-pwd
  display inline-block
  width 35px
  height 40px
  background-image url('../assets/images/icon-pwd.png')
.other-option
  span
    color #0ab5c0
    font-size: 25px; /*px*/
    padding-top 30px
    padding-bottom 30px
.wsp-btn-l
  margin 0 auto
  width 530px
  height 86px
  line-height 86px
  text-align center
  font-size: 35px; /*px*/
  letter-spacing 7px
  color #ffffff
  background-image url('../assets/images/l-btn.png')
  background-size 530px 86px
  background-repeat no-repeat
  font-weight 300
</style>



// WEBPACK FOOTER //
// src/pages/Login.vue